// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"3e4248f6","852":"5a207a10"}[chunkId] + ".chunk.js";
};